<template>
    <el-dialog @close='closeDialog' title="助力详情" :visible.sync="dialogVisible">
        <div class="help_detail_warp">
            <div class="user_info_div flex_center">
                <!-- <img :src="require('@/common/images/communityPurchases/logo.png')" alt=""> -->
                <img :src="assDetailsInfo.customericonurl" alt="">
                <span>{{assDetailsInfo.customername}}</span>
            </div>
            <p class="activity_name_text">
                <span class="color_gray">活动名称：</span>
                <span>{{assDetailsInfo.eventname}}</span>
            </p>
            <div class="help_detail_info_div">
                <div class="flex_center">
                    <p><span class="color_gray">发起时间：</span>{{assDetailsInfo.datetime}}</p>
                    <p><span class="color_gray">需助力人数：</span>{{assDetailsInfo.limitasscount}}</p>
                </div>
                <div class="flex_center">
                    <p :class="orderStatusClass(assDetailsInfo.assstatusname)"><span class="color_gray">助力状态：</span>{{assDetailsInfo.assstatusname}}</p>
                    <p><span class="color_gray">已助力人数：</span>{{assDetailsInfo.factasscount}}</p>
                </div>
            </div>
            <div class="help_detail_table_box">
                <el-table :data="helpTableData" style="width: 100%" max-height="424">
                    <el-table-column type="index" :index="indexMethod" label="序号" width="100" align='center'></el-table-column>
                    <!-- <el-table-column property="index" width="100" label="序号" align='center'></el-table-column> -->
                    <el-table-column label="用户名称">
                        <template slot-scope="scope">
                            <div class="user_box flex_center">
                                <img :src="scope.row.asscustomericonurl" alt="">
                                <span>{{scope.row.asscustomername}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column property="asstime" label="助力时间" align='center'></el-table-column>
                    <el-table-column property="assmoney" label="助力金额" align='center'></el-table-column>
                </el-table>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'HelpDetailPop',
    props: ['assDetailsInfo'],
    data() {
        return {
            dialogVisible: false,
            helpTableData: []
        }
    },
    mounted() {},
    methods: {
        // 自定义索引
        indexMethod(index) {
            return index + 1
        },
        // 打开弹窗
        openDialog() {
            this.dialogVisible = true
        },
        // 关闭弹框
        closeDialog() {
            this.dialogVisible = false
        },
        orderStatusClass(val) {
            if (val === '已取消' || val === '未完成') {
                return 'gray_text'
            } else if (val === '已完成') {
                return 'green_text'
            } else if (val === '进行中') {
                return 'yellow_text'
            }
        }
    },
    filters: {},
    watch: {
        assDetailsInfo(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                this.helpTableData = this.assDetailsInfo.asslist
                // console.log('this.assDetailsInfo:', this.assDetailsInfo)
            })
        }
    },
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .help_detail_warp {
        color: #303133;
        .flex_center {
            display: flex;
            align-items: center;
        }
        .color_gray {
            color: #606266;
        }
        .user_info_div {
            img{
                width: 50px;
                height: 50px;
                border-radius: 50%;
                margin-right: 10px;
            }
        }
        .activity_name_text {
            display: flex;
            margin: 20px 0;
            span:nth-of-type(1){
                white-space: nowrap;
                line-height: 18px;
            }
            span:nth-of-type(2){
                line-height: 18px;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
            }
        }
        .help_detail_info_div {
            .green_text {
                color: #67C23A;
            }
            .yellow_text {
                color: #E6A23C;
            }
            .gray_text {
                color: #909399;
            }
            &>div {
                p:nth-of-type(1) {
                    width: 335px;
                    line-height: 18px;
                }
            }
            &>div:nth-of-type(2) {
                margin-top: 10px;
            }
        }
        .help_detail_table_box {
            margin-top: 20px;
            // .el-table th>.cell {
            //     font-weight: bold!important;
            //     white-space: nowrap;
            //     font-size: 16px;
            // }
            .el-table__empty-block {
                min-height: 300px;
                padding-top: 200px;
                box-sizing: border-box;
            }
            .user_box{
                img{
                    width: 50px;
                    min-width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    margin-right: 10px;
                }
                span {
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
            }
        }
    }
</style>